import {toNumber} from '@raison/toolbox';
import classNames from 'classnames';
import React, {FC} from 'react';
import {NumericFormat} from 'react-number-format';
import {useSelector} from 'react-redux';
import getCurrencyClass from '~/shared/utils/currency';
import style from './PendingTransactPair.module.scss';

export interface PendingTransactPairProps {
    currency: string;
    value: string | null;
    sign: '+' | '-' | '';
    subLine?: boolean;
}

const selectTokenCodes = (store: AppModel): string[] =>
    store.assets.assets?.accounts.tokens.map(token => token.currency) ?? [];

const selectAccountsOfAllTypes = (store: AppModel) => {
    const assets = store.assets.assets;
    if (!assets) {
        return [];
    }
    return Object.values(assets.accounts).flat();
};

const PendingTransactPair: FC<PendingTransactPairProps> = ({currency, value, sign, subLine}) => {
    const assetsAccounts = useSelector(selectAccountsOfAllTypes);
    const tokenCodes = useSelector(selectTokenCodes);

    const getAmount = (currencyInput: string) => {
        let classForCurrency = getCurrencyClass(currencyInput);

        const account = assetsAccounts.find(item => item.currency === currencyInput);
        if (account && tokenCodes && tokenCodes.includes(account.currency)) {
            classForCurrency = getCurrencyClass(currencyInput, 'Token');
        }

        const decimals_assets = account?.decimals_assets;
        const valueNumber = toNumber(value);

        if (valueNumber === 0) {
            const amount = valueNumber.toFixed(decimals_assets);
            return {amount, currencyInput};
        }

        const currClass = new classForCurrency(value ?? '', decimals_assets!);
        const amount = currClass.amount;

        return {amount, currencyInput};
    };

    const localCurrency = currency.toUpperCase();
    const {amount, currencyInput} = getAmount(localCurrency);

    return (
        <NumericFormat
            prefix={sign}
            value={amount || '−−'}
            suffix={` ${currencyInput}`}
            displayType='text'
            className={classNames(style.container, {[style.subLine]: subLine}, {[style.greenColor]: sign !== '-'})}
            thousandSeparator
            allowNegative={false}
        />
    );
};
export default PendingTransactPair;
